module.exports = __webpack_public_path__ + "media/Video 134.56e3e64e.mp4";